import React, { useState, useEffect } from 'react';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Switch } from '@/components/ui/switch';
import { Checkbox } from '@/components/ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { Calendar as CalendarIcon } from "lucide-react";

import { toast } from 'react-toastify';
import Moment from 'moment';
import { motion } from "framer-motion";
import * as XLSX from 'xlsx';
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import TopBar from 'core/widgets/ui/TopBar';

import ServiceSubs from 'services/serviceSubs';

import ComponentSubInfo from 'core/widgets/components/ComponentSubInfo';

export default function PanelSubscription(props) {

    const [filter, setFilter] = useState({});
    const [selRec, setSelRec] = useState({});
    const [tempDoc, setTempDoc] = useState({});

    const [records, setRecords] = useState([]);
    const [features, setFeatures] = useState([]);
    const [apps, setApps] = useState([]);

    const [tab, setTab] = useState('all');
    const [query, setQuery] = useState('');
    const [eid, setEid] = useState('');

    const [date, setDate] = useState({
        from: Moment().startOf('month').toDate(),
        to: Moment().toDate(),
    });

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isInfo, setIsInfo] = useState(false);
    const [isRenew, setIsRenew] = useState(false);

    const subsTypes = [
        { value: 'pos', label: 'POS Subscription' },
        { value: 'con', label: 'Consumer Subscription' },
    ];

    const subsMode = [
        { value: 'demo', label: 'demo' },
        { value: 'prod', label: 'prod' },
    ];

    const payMode = [
        { value: 'demo', label: 'Demo' },
        { value: 'cash', label: 'Cash' },
        { value: 'bank', label: 'Bank' },
        { value: 'upi', label: 'UPI' },
        { value: 'chq', label: 'Cheque' },
    ];

    const subsService = new ServiceSubs();

    const formVSchema = Yup.object().shape({
        type: Yup.string().required('This information is required'),
        mode: Yup.string().required('This information is required'),
        lice: Yup.number().required('This information is required'),
        sdate: Yup.date().required('This information is required'),
        edate: Yup.date().required('This information is required'),
        total: Yup.number().required('This information is required'),
        discount: Yup.number().required('This information is required'),
        gtotal: Yup.number().required('This information is required'),
        pmode: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            type: '',
            mode: '',
            lice: '',
            sdate: '',
            edate: '',
            total: 0,
            discount: 0,
            gtotal: 0,
            pmode: '',
            pref: '',
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            setSubmit(true);
            if (isEdit) {
                let body = {
                    "uid": eid,
                    "data": {
                        "totalLicenses": values.lice,
                        "startDate": Moment(values.sdate).toISOString(),
                        "endDate": Moment(values.edate).toISOString(),
                        "features": getFeatures(),
                        "apps": apps,
                    }
                }
                subsService.updateSubscription(body, '').then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        resetForm();
                        setApps([]);
                        setFeatures([]);
                        setIsOpen(false);
                        setIsEdit(false);
                        setTempDoc({});
                        setEid('');
                        loadData();
                        toast.success('Subscription updated.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            }
        }
    });

    const onDateChange = (event) => {
        setIsDate(true);
        setDate(event);
    }

    const changeTab = (val) => {
        setTab(val);
        setQuery('');
        switch (val) {
            case "all":
                setFilter({});
                break;
            case "active":
                setFilter({ 'status': 'active' });
                break;
            case "expired":
                setFilter({ 'status': 'expired' });
                break;
            default:
                break;
        }
    }

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const switchApps = (app) => {
        let tempApps = [...apps];
        if (tempApps.includes(app)) {
            var index = tempApps.findIndex((e) => e === app);
            tempApps.splice(index, 1);
        } else {
            tempApps.push(app);
        }
        setApps(tempApps);
    }

    const switchFeatures = (feature) => {
        let tempFeat = [...features];
        if (tempFeat.includes(feature)) {
            var index = tempFeat.findIndex((e) => e === feature);
            tempFeat.splice(index, 1);
        } else {
            tempFeat.push(feature);
        }
        setFeatures(tempFeat);
    }

    const getFeatures = () => {
        return {
            "isInv": features.includes("isInv"),
            "isKds": features.includes("isKds"),
            "isRoom": features.includes("isRoom"),
            "isTax": features.includes("isTax"),
            "isCrm": features.includes("isCrm")
        };
    }

    const getDocFeatures = (features) => {
        let tempList = [];
        if (features["isInv"]) {
            tempList.push("isInv");
        }
        if (features["isKds"]) {
            tempList.push("isKds");
        }
        if (features["isRoom"]) {
            tempList.push("isRoom");
        }
        if (features["isTax"]) {
            tempList.push("isTax");
        }
        if (features["isCrm"]) {
            tempList.push("isCrm");
        }
        return tempList;
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await subsService.getAllSubs(body);
            var records = res.data.data;
            let items = [];
            records.forEach((item) => {
                items.push({
                    subid: item.subid,
                    subtype: item.subtype,
                    totalLicenses: item.totalLicenses,
                    total: item.total,
                    tax: item.tax,
                    discount: item.discount,
                    start_date: item.startDate,
                    end_date: item.endDate,
                    paymentMode: item.pmode.mode,
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "subs");
                XLSX.writeFile(workbook, "Subs.xlsx");
            } else {
                let headers = ['subid, subtype, totalLicenses, total, tax, discount, start_date, end_date, paymentMode, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { subid, subtype, totalLicenses, total, tax, discount, start_date, end_date, paymentMode, status, createdAt } = record
                    acc.push([subid, subtype, totalLicenses, total, tax, discount, start_date, end_date, paymentMode, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Subs.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const changeDate = (e) => {
        var { value, name } = e.target;
        switch (value) {
            case "prod":
                setValues({ ...values, mode: value, sdate: Moment().format("yyyy-MM-DD"), edate: Moment().add(1, 'year').format("yyyy-MM-DD") });
                break;
            case "demo":
                setValues({ ...values, mode: value, sdate: Moment().format("yyyy-MM-DD"), edate: Moment().add(1, 'month').format("yyyy-MM-DD"), });
                break;
        }
    }

    const getTaxVal = () => {
        return (values.total - values.discount) * 0.18;
    }

    const getGTotalVal = () => {
        return (values.total - values.discount) + getTaxVal();
    }

    const editRecord = (doc) => {
        setTempDoc(doc);
        setEid(doc._id);
        setIsEdit(true);
        setIsOpen(true);
    }

    const openInfo = (rec) => {
        setSelRec(rec);
        setIsInfo(true);
        setIsRenew(false);
    }

    const openRenew = (rec) => {
        setIsRenew(true);
        setSelRec(rec);
        setIsInfo(true);
    }

    const closeInfo = () => {
        setIsInfo(false);
        setIsRenew(false);
        setSelRec({});
        loadData();
    }

    const populdata = () => {
        setValues({
            type: 'pos',
            mode: tempDoc.subtype,
            lice: tempDoc.totalLicenses,
            sdate: Moment(tempDoc.startDate).format("yyyy-MM-DD"),
            edate: Moment(tempDoc.endDate).format("yyyy-MM-DD"),
            total: tempDoc.total,
            discount: tempDoc.discount,
            gtotal: 0,
            pmode: tempDoc.pmode.mode,
            pref: tempDoc.pmode.ref,
        });
        setFeatures(getDocFeatures(tempDoc.features));
        setApps(tempDoc.apps);
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": "",
                "endDate": ""
            };
            var res = await subsService.getAllSubs(body, '');
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": "",
                "endDate": ""
            };
            var res = await subsService.getAllSubs(body, '');
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, filter]);

    useEffect(() => {
        if (isOpen && isEdit) {
            populdata();
        }
    }, [isOpen, isEdit, tempDoc]);

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>{isEdit ? "UPDATE" : "ADD"} SUBSCRIPTION</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setIsOpen(false);
                                        setApps([]);
                                        setFeatures([]);
                                        resetForm();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <form className='mt-4 grid grid-cols-12 gap-3' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Subscription Type<sup className="text-red-600">*</sup></label>
                                        <select id="type" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" disabled={isEdit} onChange={handleChange} value={values.type}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                subsTypes.length !== 0 && subsTypes.map((item) => {
                                                    return <option value={item.value} selected={values.type == item.value}>{item.label}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.type && touched.type) && <p className='text-xs text-red-400 mt-1'>{errors.type}</p>}
                                    </div>

                                    <div className="col-span-8"></div>

                                    {
                                        values.type === "pos" && <div className='col-span-12 grid grid-cols-12 gap-3'>
                                            <div className="col-span-12 font-medium">
                                                Subscription information
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Subscription Mode<sup className="text-red-600">*</sup></label>
                                                <select id="mode" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" disabled={isEdit} onChange={(e) => {
                                                    changeDate(e);
                                                }} value={values.mode}>
                                                    <option value="" disabled="" selected="selected">Select</option>
                                                    {
                                                        subsMode.length !== 0 && subsMode.map((item) => {
                                                            return <option value={item.value} selected={values.mode == item.value}>{item.label}</option>
                                                        })
                                                    }
                                                </select>
                                                {(errors.mode && touched.mode) && <p className='text-xs text-red-400 mt-1'>{errors.mode}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">No. of License<sup className="text-red-600">*</sup></label>
                                                <input type="number" id="lice" value={values.lice} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. 1" onChange={handleChange} />
                                                {(errors.lice && touched.lice) && <p className='text-xs text-red-400 mt-1'>{errors.lice}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Start Date<sup className="text-red-600">*</sup></label>
                                                <input type="date" id="sdate" value={values.sdate} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" onChange={handleChange} />
                                                {(errors.sdate && touched.sdate) && <p className='text-xs text-red-400 mt-1'>{errors.sdate}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">End Date<sup className="text-red-600">*</sup></label>
                                                <input type="date" id="edate" value={values.edate} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" onChange={handleChange} />
                                                {(errors.edate && touched.edate) && <p className='text-xs text-red-400 mt-1'>{errors.edate}</p>}
                                            </div>

                                            <div className="col-span-12 grid grid-cols-5 gap-4">
                                                <div className='col-span-5 font-medium text-sm'>
                                                    Features information
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='mt-1 flex items-center'>
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">KDS</label>
                                                        <Switch checked={features.includes("isKds")} onCheckedChange={(e) => { switchFeatures("isKds") }} className="ml-2" />
                                                    </div>
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='mt-1 flex items-center'>
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">Room Booking</label>
                                                        <Switch checked={features.includes("isRoom")} onCheckedChange={(e) => { switchFeatures("isRoom") }} className="ml-2" />
                                                    </div>
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='mt-1 flex items-center'>
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">Inventory</label>
                                                        <Switch checked={features.includes("isInv")} onCheckedChange={(e) => { switchFeatures("isInv") }} className="ml-2" />
                                                    </div>
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='mt-1 flex items-center'>
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">Tax Setting</label>
                                                        <Switch checked={features.includes("isTax")} onCheckedChange={(e) => { switchFeatures("isTax") }} className="ml-2" />
                                                    </div>
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='mt-1 flex items-center'>
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">CRM Module</label>
                                                        <Switch checked={features.includes("isCrm")} onCheckedChange={(e) => { switchFeatures("isCrm") }} className="ml-2" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-span-12 grid grid-cols-4 gap-4">
                                                <div className='col-span-4 font-medium text-sm'>
                                                    Apps
                                                </div>
                                                <div className='col-span-1'>
                                                    <div className='flex items-center'>
                                                        <Checkbox checked={apps.includes("APP00001")} onCheckedChange={(e) => { switchApps("APP00001"); }} className="mr-2" />
                                                        <label className="block text-xs font-medium text-gray-700 font-mono">Online Reporting<sup className="text-red-600">*</sup></label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-span-12 font-medium">
                                                Payment information
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Total<sup className="text-red-600">*</sup></label>
                                                <input type="number" id="total" value={values.total} autoComplete='off' readOnly={isEdit} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" onChange={handleChange} />
                                                {(errors.total && touched.total) && <p className='text-xs text-red-400 mt-1'>{errors.total}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Discount<sup className="text-red-600">*</sup></label>
                                                <input type="number" id="discount" value={values.discount} autoComplete='off' readOnly={isEdit} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" onChange={handleChange} />
                                                {(errors.discount && touched.discount) && <p className='text-xs text-red-400 mt-1'>{errors.discount}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Tax (18%)<sup className="text-red-600">*</sup></label>
                                                <input type="number" id="tax" readOnly={true} value={getTaxVal()} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" />
                                                {(errors.tax && touched.tax) && <p className='text-xs text-red-400 mt-1'>{errors.tax}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Grand Total<sup className="text-red-600">*</sup></label>
                                                <input type="number" id="gtotal" readOnly={true} value={getGTotalVal()} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" />
                                                {(errors.gtotal && touched.gtotal) && <p className='text-xs text-red-400 mt-1'>{errors.gtotal}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Payment Mode<sup className="text-red-600">*</sup></label>
                                                <select id="pmode" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" disabled={isEdit} onChange={handleChange} value={values.pmode}>
                                                    <option value="" disabled="" selected="selected">Select</option>
                                                    {
                                                        payMode.length !== 0 && payMode.map((item) => {
                                                            return <option value={item.value} selected={values.pmode == item.value}>{item.label}</option>
                                                        })
                                                    }
                                                </select>
                                                {(errors.pmode && touched.pmode) && <p className='text-xs text-red-400 mt-1'>{errors.pmode}</p>}
                                            </div>

                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Payment Ref</label>
                                                <input type="text" id="pref" value={values.pref} readOnly={isEdit} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxx" onChange={handleChange} />
                                                {(errors.pref && touched.pref) && <p className='text-xs text-red-400 mt-1'>{errors.pref}</p>}
                                            </div>

                                            <div className='col-span-12 my-6'>
                                                <div className='flex items-end'>
                                                    <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                        {!submit && "SAVE"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {
                isInfo && <ComponentSubInfo record={selRec} isRenew={isRenew} onClose={closeInfo} />
            }
            <ScrollArea className='h-screen w-full'>
                <div className="w-full h-full py-3 px-3">
                    <div className="grid grid-cols-12 grid-gap-2">
                        <div className="col-span-12 mt-2">
                            <div class="intro-y flex items-center justify-between h-10 border-b pb-4">
                                <h2 class="text-2xl font-medium font-serif truncate ml-2">
                                    Subscription Master
                                </h2>
                                <TopBar />
                            </div>
                            <div class="w-full mt-4 flex justify-between items-center">
                                <div className='h-10 bg-gray-100 rounded'>
                                    <ul className="intro-y flex text-sm font-sans">
                                        <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'all' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('all') }}>All</button></li>
                                        <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'active' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('active') }}>Active</button></li>
                                        <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'expired' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('expired') }}>Expired</button></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 mt-4">
                        <div className="w-full shadow-md rounded-md border">
                            <table className="min-w-full divide-y divide-gray-200 px-4">
                                <thead className="bg-gray-50">
                                    <tr className=''>
                                        <th scope="col" className="border-b border-gray-200" colSpan={10}>
                                            <div className='w-full grid grid-cols-12 gap-2'>
                                                <form className="items-center py-2 col-span-11 px-2 grid grid-cols-12 gap-2">
                                                    <div className='col-span-3 flex'>
                                                        <Popover>
                                                            <PopoverTrigger asChild>
                                                                <Button id="date" variant={"outline"}
                                                                    className={cn(
                                                                        "w-[300px] justify-start text-left font-normal",
                                                                        !date && "text-muted-foreground"
                                                                    )}
                                                                >
                                                                    <CalendarIcon className="mr-2 h-4 w-4" />
                                                                    {date?.from ? (
                                                                        date.to ? (
                                                                            <>
                                                                                {Moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                                {Moment(date.to).format('MMM DD, yyyy')}
                                                                            </>
                                                                        ) : (
                                                                            Moment(date.from).format('MMM DD, yyyy')
                                                                        )
                                                                    ) : (
                                                                        <span>Pick a date</span>
                                                                    )}
                                                                </Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="w-auto p-0" align="start">
                                                                <Calendar
                                                                    initialFocus
                                                                    mode="range"
                                                                    defaultMonth={date?.from}
                                                                    selected={date}
                                                                    onSelect={onDateChange}
                                                                    numberOfMonths={2}
                                                                />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                    <div className='w-full flex col-span-9 items-center'>
                                                        <div className='w-[80px]'>
                                                            <p>Search :</p>
                                                        </div>
                                                        <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by name and email." className="w-full h-10 px-4 font-sans text-sm outline-none rounded border" />
                                                    </div>
                                                </form>
                                                <div className='col-span-1 flex items-center'>
                                                    <DropdownMenu>
                                                        <DropdownMenuTrigger>
                                                            <button className="w-full py-1 px-2 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4"><i className="las la-file-download mr-2"></i> Export </button>
                                                        </DropdownMenuTrigger>
                                                        <DropdownMenuContent>
                                                            <div
                                                                className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                                <div>
                                                                    <ul className='flex flex-col items-start p-2'>
                                                                        <DropdownMenuItem>
                                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                                exportData('xlsx');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                        <DropdownMenuItem>
                                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                                exportData('csv');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </DropdownMenuContent>
                                                    </DropdownMenu>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            SUB ID
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            SUB TYPE
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Num Licenses
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Total
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Discount
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Payment Mode
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Start Date
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            End Date
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Status
                                        </th>
                                        <th scope="col" className="px-2 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {
                                        records.length !== 0 && records.map((rec) => {
                                            return <tr className="hover:bg-gray-100" key={rec._id}>
                                                <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => { openInfo(rec) }}>
                                                    <div className="text-sm font-bold text-gray-900">
                                                        <div className='flex items-center text-prime uppercase'>
                                                            {rec.subid}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900 uppercase">
                                                        <div>{rec.subtype}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900">
                                                        <div>{rec.totalLicenses} (.lic)</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900 uppercase">
                                                        <div>₹ {rec.total.toFixed(2)}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900 uppercase">
                                                        <div>₹ {rec.discount.toFixed(2)}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900 uppercase">
                                                        <div>{rec.pmode.mode}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900">
                                                        <div>{Moment(rec.startDate).format('DD, MMM yyyy')}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900">
                                                        <div>{Moment(rec.endDate).format('DD, MMM yyyy')}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${rec.status == 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                                        {rec.status.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td>
                                                    <DropdownMenu>
                                                        <DropdownMenuTrigger>
                                                            <motion.i whileHover={{ scale: 1.1 }} class="las la-ellipsis-v text-lg"></motion.i>
                                                        </DropdownMenuTrigger>
                                                        <DropdownMenuContent>
                                                            <div>
                                                                <ul className='flex flex-col items-start'>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                            editRecord(rec);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-edit text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Edit</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                            openRenew(rec);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-sync text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Renew</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </DropdownMenuContent>
                                                    </DropdownMenu>
                                                </td>
                                            </tr>
                                        })
                                    }
                                    {
                                        records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                            <td className="px-6 py-4 whitespace-nowrap" colSpan="10">
                                                <div className="text-sm text-red-600 text-center">
                                                    No data found.
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            <div className='flex py-2 px-4 items-center bg-blue-50'>
                                <p className='text-sm font-serif'>Show rows per page</p>
                                <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={40}>40</option>
                                    <option value={50}>50</option>
                                </select>
                                <div className='flex-grow'></div>
                                <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                                <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                                <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            </div>
                        </div>
                    </div>
                </div >
            </ScrollArea>
        </>
    );
}
